import React, { useState } from "react";
import { useAppContext } from "../../libs/contextLib";
import { UserService } from "../../services/user";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Factory } from "../../helpers/factories";
import Roles from "../../helpers/roles";

export default function SearchUser({
  label = "Search User",
  user,
  setUser,
  role,
  isDisabled,
  isReadOnly,
  ...props
}) {
  const { currentUser } = useAppContext();

  //autocomplete suggestions
  const [searchSettings, setSearchSettings] = useState({
    userName: "",
    suggestions: [],
  });

  //autcomplete loading
  const [loading, setLoading] = useState(true);

  //handle key change
  const handleChange = (e) => {
    //query options
    let queryOptions = {
      name: e.target.value,
      // role: role,
    };
    if (role) {
      queryOptions.role = role;
    }
    //call api
    (async () => {
      try {
        const filteredUsers = await UserService.getUserByOrgId(
          currentUser.organisation.id,
          queryOptions
        );

        setSearchSettings({
          ...searchSettings,
          suggestions: filteredUsers,
        });

        setLoading(false);
      } catch (err) {
        setSearchSettings({
          ...searchSettings,
          suggestions: [],
        });
      }
    })();
  };

  //return component

  return (
    <Autocomplete
      id="asynchronous-demo"
      //size="small"
      disabled={isDisabled}
      style={{ width: "90%", margin: "16px" }}
      loading={loading}
      freeSolo
      defaultValue={() => {
        return user ? user : Factory.createUser();
      }}
      onChange={(e, v) => {
        if (v != null) {
          setUser(v);
        } else {
          setUser(Factory.createUser());
        }
      }}
      getOptionSelected={(option, value) => {
        // console.log("OPTION", option);
        // console.log("VALUE", value);
        return option.firstName === value.firstName;
      }}
      getOptionLabel={(option) => {
        return option.firstName ? option.firstName + " " + option.lastName : "";
      }}
      renderOption={(option) => {
        // console.log("opton", option);
        return (
          <div
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", marginRight: "10px   " }}>
              <Avatar src={option.picURL} alt={option.firstName} />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body2">
                {option.firstName + " " + option.lastName}
              </Typography>
              <Typography
                variant="caption"
                style={{ textTransform: "capitalize" }}
              >
                {option.role === "student" && `${option.username}, `}
                {Roles[option.role].displayName}{" "}
                {option.role === "student" && `, Grade ${option.grade}`}
                {option.role === "student" &&
                  `, Sec ${option.groupSection ? option.groupSection : ""}`}
              </Typography>
              <Typography variant="caption">{option.email}</Typography>
              {/* <img src={option.picUrl} alt="user image" /> */}
            </div>
          </div>
        );
      }}
      options={searchSettings.suggestions}
      //   loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputProps={{ ...params.InputProps, readOnly: isReadOnly }}
          onChange={handleChange}
        />
      )}
    />
  );
}
